import { Component } from '@angular/core';
import Swiper from 'swiper';
import { Autoplay, EffectCoverflow, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
@Component({
    selector: 'app-carousel',  standalone: true,

    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    
      imports:[...PRIMENG_MODULES]
})
export class CarouselComponent {

    constructor(
    ) { }
    ngAfterViewInit() {
        new Swiper(".swiper", {
            modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectCoverflow, Keyboard, Mousewheel],
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 3,
                slideShadows: true
            },
            autoplay: {
                delay: 850, // Time in milliseconds between slides
                disableOnInteraction: false, // Continue autoplay after user interaction (e.g., swipe)
                pauseOnMouseEnter: true,
            },
            keyboard: {
                enabled: true
            },
            mousewheel: {
                thresholdDelta: 70
            },
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            breakpoints: {
                640: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 1
                },
                1024: {
                    slidesPerView: 2
                },
                1560: {
                    slidesPerView: 3
                }
            }
        });
    }
}
